import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { UtilsService } from 'src/app/core/services/utils.service';

@Injectable({
  providedIn: 'root',
})
export class CostFormService extends BaseProvider {
  costs: any = [];
  selectedCosts: any = [];
  dynamicCosts: any = [];

  subTotal: any = 0;  
  total: any = 0;  

  taxAmount: any = 0;  
  discountAmount: any = 0;  
  
  totalOfNewCosts: any;
  costsAdded: boolean = true;
  dynamicCostsAdded: boolean = false;

  minimumCostsAdded: boolean = false;
  minimumCostSelectedCount: any = 0;
  minRequiredCosts: any = [];

  // Cost rules validation
  costRulesConfiguration: any = null;
  costRulesValidationError: string = '';
  isCostRulesValid: boolean = true;

  constructor(
    public globals: GlobalsService,
    public http: HttpClient,
    public utils: UtilsService,
  ) {
    super();
   
    this.baseUrl = 'userProcessCost';
  }

  save(processId, data){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + "/" + processId;

      this.http
      .post(this.url, data)
      .subscribe(
          (data:any) => {
            resolve(data)
           },
          (err:any) => {
            reject(err)
           }
      );
    });    
  }
  createNonDynamicCosts(processId){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + "/noDynamicCosts/" + processId;

      this.http
      .post(this.url, null)
      .subscribe(
        (data:any) => {
          resolve(data)
        },
        (err:any) => {
          reject(err)
        }
      );
    });    

  }
  getCosts(processId, costTypeId) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/${processId}` + `/costType/${costTypeId}`;

      this.http.get(this.url).subscribe(
        (data: any) => {
          console.log('getCosts API response:', data);
          this.costs = data.Data;
          this.costsAdded = true;
          
          // Parse CostRulesConfiguration from first cost item (rules are same for all)
          this.costRulesConfiguration = null;
          if (data.Data && data.Data.length > 0 && data.Data[0].CostRulesConfiguration) {
            const rulesConfig = data.Data[0].CostRulesConfiguration;
            console.log('CostRulesConfiguration from API:', rulesConfig);
            try {
              this.costRulesConfiguration = typeof rulesConfig === 'string' 
                ? JSON.parse(rulesConfig) 
                : rulesConfig;
              console.log('Parsed CostRulesConfiguration:', this.costRulesConfiguration);
            } catch (e) {
              console.error('Error parsing CostRulesConfiguration:', e);
            }
          }
          
          resolve(data.Data);
        },
        (err) => {
          this.costsAdded = false;
          reject(err);
        }
      );
    });
  }

  getDynamicCosts(invoiceId) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/dynamic/invoice/${invoiceId}`;

      this.http.get(this.url).subscribe(
        (data: any) => {

         

          this.dynamicCosts = data.Data;

         
          for(var i = 0; i<this.dynamicCosts.length; i++){
            this.dynamicCosts.Costs = JSON.parse(this.dynamicCosts[i].Costs);
          }

          console.log(this.dynamicCosts.Costs);
          resolve(this.dynamicCosts);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }
 
  
  getInvoiceDetail(processId) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/invoice/detail/process/${processId}`;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.dynamicCosts = data.Data;

          resolve(data.Data);
        },
        (err) => {

          reject(err);
        }
      );
    });
  }

  manageCost(obj:any){
    let foundItem = this
            .utils
            .returnItemFromListByAttr(this.selectedCosts, "Id", obj.cost.Id);  

    if(!this.utils.isEmpty(foundItem)){
      this
      .utils
      .updateItemFromListByAttr(
        this.selectedCosts, "Id", 
          {
            ...obj.cost,
            ...{Qty:parseInt(obj.qty)}  
          }
      );
    }else{
      this.selectedCosts.push({
        ...obj.cost,
        ...{Qty:parseInt(obj.qty)}          
      });  
    }    
  }  

  removeCost(cost){
    this
    .utils
    .removeItemFromListByAttr(
      this.selectedCosts, 
      "Id",
      cost      
    );    
  }  

  setTotal(){
    this.subTotal = 0;

    this.selectedCosts.forEach((element:any, index) => {
      var amount = (element.FixedAmount>0) ? element.FixedAmount : element.Amount;

      this.subTotal += (amount*element.Qty);
    });    

    this.total = this.subTotal;

    this.total = this.total + this.taxAmount;

    this.setDiscount();
  }  

  setDiscount(){
    if(this.discountAmount<=this.subTotal){
      this.total = (this.subTotal - this.discountAmount) + this.taxAmount;    
    }    
  }  

  setInvoiceTotal(){
    this.subTotal = 0;

    this.selectedCosts.forEach((element:any, index) => {
      var amount = (element.FixedAmount>0) ? element.FixedAmount : element.Amount;

      this.subTotal += (amount*element.Qty);
    });    

    this.total = this.subTotal;

    this.total = this.total + this.taxAmount;

    this.dynamicCostsAdded = false;
    if(this.total > 0){
      this.dynamicCostsAdded = true;
    }
    this.setDiscount();
  }

  /**
   * Validates the current selection against cost rules configuration
   * Returns true if valid, false if invalid
   */
  validateCostRules(): boolean {
    this.costRulesValidationError = '';
    this.isCostRulesValid = true;

    if (!this.costRulesConfiguration || !this.costRulesConfiguration.costCalculatorRules) {
      return true;
    }

    // Count non-required selected costs (user selections only)
    const userSelectedCount = this.selectedCosts.filter(c => !c.IsRequired).length;

    for (const rule of this.costRulesConfiguration.costCalculatorRules) {
      const minAllowed = rule.minCostAllowed ? rule.minCostAllowed : 0;
      const maxAllowed = rule.maxCostAllowed ? rule.maxCostAllowed : Infinity;

      if (userSelectedCount < minAllowed) {
        this.costRulesValidationError = `Debe seleccionar al menos ${minAllowed} costo(s).`;
        this.isCostRulesValid = false;
        return false;
      }

      if (userSelectedCount > maxAllowed) {
        this.costRulesValidationError = `Debe seleccionar un máximo de ${maxAllowed} costo(s).`;
        this.isCostRulesValid = false;
        return false;
      }
    }

    return true;
  }
}
